import React from 'react';

interface ILayoutLogin {
    children?: React.ReactNode
}

const LayoutLogin = ({
    children
}: ILayoutLogin) => {
    return (
        <div className='grid grid-cols-1 md:grid-cols-10 lg:grid-cols-10 min-w-full min-h-full'>
            <div className='hidden md:flex md:col-span-4 lg:col-span-4 h-screen sticky bottom-0 top-0 max-w-full'>
                <div className='absolute top-0 bottom-0 left-0 right-0'>
                    <div className='min-w-full min-h-full flex flex-row justify-center align-center'>
                        <img alt='logo' src={'/assets/auth/auth-logo.svg'} className={'object-contain w-[40%]'} />
                    </div>
                </div>
                <img alt='auth process' src={'/assets/auth/login.png'} className={'w-full h-full object-bottom object-cover'} />
            </div>
            <div className='col-span-1 md:col-span-6 lg:col-span-6 min-h-[100vh] p-6 bg-[#fff]'>
                {children}
            </div>
        </div >
    )
}

export default LayoutLogin;